<template>
    <div class="tab-inner-content">
        <div class="not-installed-wrapper">
            <div class="not-installed-content">
                <img v-if="(activeContent.not_install_icon.icon_type == 'img')"
                     :src="activeContent.not_install_icon.icon" alt="">
                <p><span v-if="activeContent.headers">{{activeContent.headers.title}}</span> is not installed</p>
                <span class="divider"></span>
                <p>To enable real time alerts when you are on a dangerous site, <br/>please click Add to
                    {{userAgent.browser.name}}</p>
                <a href="" class="btn btn-lg default-btn" @click.prevent="installExtension(activeContent.type)">Add to
                    {{userAgent.browser.name}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['brand', 'userAgent', 'activeContent'],
        name: "NotInstall",
        methods: {
            installExtension: function (extensionsType) {
                return this.$parent.installExtension(extensionsType);
            }
        }
    }
</script>

<style scoped>
    .safely .btn.default-btn {
        background-color: #03a9f4;
    }

    .safely .btn.default-btn:hover .corner-arrow {
        border-color: #03a9f4;
    }

    .safely .btn.default-btn:hover {
        color: #03a9f4;
        border-color: #03a9f4;
        background-color: #fff;
    }


    .show-tab .tab-inner-content {
        opacity: 1;
        transition: all .5s ease-out;
    }

    .tab-content.centered-item,
    .tab-inner-content.centered-item,
    .tab-inner-content .centered-item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .not-installed-wrapper {
        text-align: center;
        font-size: 20px;
        width: 100%;
        line-height: 1;
        height: 100%;
        padding: 90px 20px 20px 20px;
        display: flex;
        justify-content: center;
        overflow: auto;
    }

    .not-installed-wrapper .divider {
        width: 80px;
    }

    .divider {
        display: block;
        margin: 30px auto;
        height: 1px;
        background-color: #4a4b4b;
    }

    .not-installed-wrapper p {
        margin: 20px 0;
        line-height: 28px;
    }

    .not-installed-wrapper .btn.btn-lg {
        padding: 15px 40px;
    }

    @media all and (max-height: 768px) {
        .extension-link-tab {
            padding: 17px 40px;
        }

        .extension-icon {
            width: 40px;
        }

        .not-installed-wrapper {
            padding-top: 50px;
        }

        .text-static-content h3 {
            margin-bottom: 15px;
        }

        #about-tab .divider {
            margin-top: 15px;
            margin-bottom: 15px;
        }
    }


</style>